import {Component, OnInit} from '@angular/core';
import {Subject} from 'rxjs';
import {ActivatedRoute, Router} from '@angular/router';
import {UniversityRecruiterService} from '../../../shared/services/university-recruiter.service';
import {UniversityService} from '../../../shared/services/university.service';
import {GlobalService} from '../../../shared/services/global.service';

@Component({
    selector: 'app-university-recruiter',
    templateUrl: './university-recruiter.component.html',
    styleUrls: ['./university-recruiter.component.scss']
})
export class UniversityRecruiterComponent implements OnInit {
    public name: any;
    public logoFileId: any;
    public logoPreviewUrl: any;
    public toggleMenu = false;
    private _unsubscribeAll: Subject<any>;
    public universityId: any;
    recruiters: any = [];
    submitting: any = false;
    uploadingLogo: any = false;
    university: any;

    constructor(private router: Router,
                private activatedRoute: ActivatedRoute,
                private universityRecruiterService: UniversityRecruiterService,
                private universityService: UniversityService,
                private globalService: GlobalService) {
        this._unsubscribeAll = new Subject();
    }

    ngOnInit(): void {
        this.universityId = this.activatedRoute.snapshot.params['id'];
        this.refresh();
    }

    refresh() {
        this.getUniversityDetail();
    }

    getUniversityDetail() {
        this.universityService.detail(this.universityId).subscribe(data => {
            if (data) {
                this.university = data;
                this.get();
            }
        });
    }

    get() {
        this.universityRecruiterService.getByAdmin(this.universityId).subscribe(data => {
            this.recruiters = (data && data.length > 0) ? data : [];
        });
    }

    onLogoSelected(event) {
        this.uploadingLogo = true;
        const params = {
            type: 'UNIVERSITY_RECRUITER_LOGO',
            fileType: 'NORMAL',
            university_id: this.universityId,
            user_id: this.globalService.getSelf() ? this.globalService.getSelf().userId : ''
        };
        this.universityRecruiterService.fileUpload(params, event).subscribe(data => {
            this.uploadingLogo = false;
            if (data && data['data']) {
                this.logoFileId = data['data'].id;
                this.logoPreviewUrl = data['data'].url;
            }
        }, error => {
            this.uploadingLogo = false;
        });
    }

    addDetail() {
        const params = {
            name: this.name ? this.name : '',
            logo_file_id: this.logoFileId ? this.logoFileId : '',
            sort_order: this.recruiters ? this.recruiters.length : 0
        };
        this.submitting = true;
        this.universityRecruiterService.createByAdmin(this.universityId, params).subscribe(data => {
            this.submitting = false;
            this.name = undefined;
            this.logoFileId = undefined;
            this.logoPreviewUrl = undefined;
            this.get();
        }, error => {
            this.submitting = false;
        });
    }

    delete(id) {
        this.universityRecruiterService.deleteByAdmin(this.universityId, id).subscribe(data => {
            this.get();
        });
    }

    goTo(tab) {
        this.router.navigateByUrl('university/' + this.universityId + '/' + tab);
    }
}
